import React, { Suspense, useEffect } from 'react';
import { useSelector, useDispatch, batch } from 'react-redux';
import { Grid, GridItem } from '@chakra-ui/react';
import Header from 'components/Header';
import Sidebar from 'components/Sidebar';
import Router from 'components/Router';
import { EntityPageSkeletor } from 'components/Skeletons';
import {
  fetchAll as getConsts,
  fetchCustomProductGroups,
} from 'store/consts/consts.actions';
import { fetchAllAdSlots } from 'store/adslots';
import { fetchAllAdFormats } from 'store/adformats';
import { fetchAllClients } from 'store/clients';
import {
  selectIfPublisherCanSetCustomProductGroups,
  getPreferences,
} from 'store/user';
import { fetchAllProductExtraFees } from 'store/productExtraFees';
import { fetchAllAdTypeExtraFees } from 'store/adTypeExtraFees';
import { startConnecting } from 'store/notifications/notification.slice';
import { userHasRequiredPermissions, useAppSelector } from 'hooks';
import {
  CAN_VIEW_PRODUCT_METADATA /* CAN_VIEW_USERS */,
} from 'consts/permissions';
import { Favicon } from 'components/Meta';

const OnAuthorizedLoad = () => {
  const customProductGroups = useAppSelector(
    selectIfPublisherCanSetCustomProductGroups,
  );
  const dispatch = useDispatch();
  const allowedToFetchProductMetadata = userHasRequiredPermissions([
    CAN_VIEW_PRODUCT_METADATA,
  ]);

  //const allowedToFetchUsers = userHasRequiredPermissions([CAN_VIEW_USERS]);

  useEffect(() => {
    batch(() => {
      dispatch(getConsts());
      dispatch(fetchAllAdSlots());
      dispatch(fetchAllAdFormats());
      dispatch(fetchAllClients());
      dispatch(startConnecting());
      dispatch(getPreferences());
    });
  }, [dispatch]);

  useEffect(() => {
    if (allowedToFetchProductMetadata) {
      dispatch(fetchAllAdTypeExtraFees());
      dispatch(fetchAllProductExtraFees());
    }
  }, [dispatch]);

  /*   useEffect(() => {
    if (allowedToFetchUsers) {
      dispatch(fetchAllUsers());
    }
  }, [dispatch]);
 */
  useEffect(() => {
    if (customProductGroups) {
      dispatch(fetchCustomProductGroups());
    }
  }, [dispatch]);

  return null;
};

function App() {
  const isLoggedIn = useSelector(state => state.user.isLoggedIn);
  return (
    <>
      <Favicon />
      <Grid
        h='100vh'
        templateAreas={`
            "sidebar header"
            "sidebar body"
          `}
        templateColumns='auto 1fr'
        templateRows='auto 1fr'
      >
        {isLoggedIn && (
          <>
            <OnAuthorizedLoad />
            <Sidebar gridArea='sidebar' />
            <Header gridArea='header' />
          </>
        )}
        <GridItem gridArea='body' minWidth={0} overflow='hidden'>
          <Suspense fallback={<EntityPageSkeletor />}>
            <Router />
          </Suspense>
        </GridItem>
      </Grid>
    </>
  );
}

export default App;
